import { HistoricalVisitSimple, HistoricalVisitSimpleQuery } from '@dreryk/egabinet-visit-frontend-api';

import { UseCqrsQueryResult, useCqrsSearch } from '@dreryk/command-query-react-common';
import { Direction, paginations } from '@dreryk/command-query-ws-client';
import { Slot } from '@dreryk/watermelon';

export const useHistoricalVisitsCqrsGet = (
   patientId: number,
   currentVisitId: number
): UseCqrsQueryResult<HistoricalVisitSimple[]> => {
   return useCqrsSearch(() => {
      const query: HistoricalVisitSimpleQuery = new HistoricalVisitSimpleQuery();
      query.patientId = patientId;
      query.excludedVisitId = Slot.of(currentVisitId);
      return query;
   }, paginations.all<HistoricalVisitSimple>().orderedBy('date', Direction.DESCENDING));
};
